import React, { useContext } from 'react';
import useGetUser from 'hooks/useGetUser';
import { PreferencesContext } from 'context/PreferencesProvider';
import NationalDashboard from './NationalDashboard';
import AgencyDashboard from './AgencyDashboard';
import MedicalDashboard from './MedicalDashboard';
import PassportDashboard from './PassportDashboard';
import BankDashboard from './BankDashboard';

const Dashboard = () => {
  const { isAGLO, isSuperAdmin, isAgency, isMS, isMAEC, isBank, user, activeOrganizationId, activeRole } = useGetUser();
  const { campaignYear, selectedCampaignYear } = useContext(PreferencesContext);
  const scope = JSON.stringify([
    user?.id,
    activeOrganizationId,
    activeRole,
    isAGLO ? selectedCampaignYear : campaignYear,
  ]);
  if (isAGLO || isSuperAdmin) return <NationalDashboard key={scope} />;
  if (isAgency) return <AgencyDashboard key={scope} />;
  if (isMS) return <MedicalDashboard key={scope} />;
  if (isMAEC) return <PassportDashboard key={scope} />;
  if (isBank) return <BankDashboard key={scope} />;
  return null;
};
export default Dashboard;
